//API Predictive dashboard

export const GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS = 'GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS';
export const GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS_SUCESS = 'GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS_SUCESS';
export const GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS_FAILURE = 'GET_API_PREDICTIVE_DASH_PEPSI_VS_NON_COMPETITORS_FAILURE';